import { render, staticRenderFns } from "./Print126Project6.vue?vue&type=template&id=ba4d7162&scoped=true&"
import script from "./Print126Project6.vue?vue&type=script&lang=js&"
export * from "./Print126Project6.vue?vue&type=script&lang=js&"
import style0 from "./Print126Project6.vue?vue&type=style&index=0&id=ba4d7162&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4d7162",
  null
  
)

export default component.exports